<template>
    <div>
        <form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title has-text-white">Add a New User to The Company</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
                    <section class="modal-card-body has-background-dvodark">
                        <b-field label="User Email To Add">
                            <b-input expanded v-model="selectedUser" placeholder="User"></b-input>
                        </b-field>
                        <b-field label="Add User's Permission Group">
                            <b-select expanded v-model="selectedJob" placeholder="Permission Group">
                                <option class="has-text-white" selected="selected">
                                </option>
                                <option class="has-text-white" v-for="option in jobs" :value="option.id"
                                    :key="option.id">
                                    {{ option.name }}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field label="User's Additional Roles">
                        <b-taginput
                            v-model="selectedRoles"
                            :data="filteredRoles"
                            autocomplete
                            :allow-new="false"
                            :open-on-focus="true"
                            field="name"
                            icon="label"
                            placeholder="Add a Role"
                            @typing="getFilteredRoles">
                        </b-taginput>
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="is-dvogreen" @click="addCompanyRole();">Make Request</b-button>
                    </footer>
                </div>
        </form>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { personCompanyRoleHandler, roleReader} from '../graphql/mutations'
import { personReader, jobsFromCompanyReader, rolesFromJobsReader} from '../graphql/queries'

export default {
    data(){
    return{
        users: [],
        roles: [],
        jobs: [],
        id: this.companyId.company_id,
        selectedUser: null,
        selectedRoles: [],
        selectedJob: null,
        jobRoles: [],
        filteredRoles: []
    }
    },
    props: ['companyId'],
    computed:{
        computedUser(){
            if (this.selectedUser.first_name){
                return this.selectedJob.first_name
            } else {
                return ''
            }
        }
    },
    methods:{
    async getUsers() {
        const Users = await API.graphql({
            query: personReader, 
            variables: { 
                input: {
                request_type: 'read_all'
            }}
        });
        this.users = Users.data.personReader;
    },
    async getRoles() {
        const Roles = await API.graphql({
            query: roleReader, 
            variables: { 
                input: {
                request_type: 'read_all'
            }}
        });
        this.roles = Roles.data.roleReader;
    },
    async getJobsForCompany(){
        const jobHolder = await API.graphql({
            query: jobsFromCompanyReader,
            variables: {
                input: {
                    request_type: 'find_job_by_company',
                    company_id: Number(this.id)
                }
            }
        });
        this.jobs = jobHolder.data.jobsFromCompanyReader
    },
    getFilteredRoles(text) {
                this.filteredRoles = this.roles.filter((option) => {
                    return option.name
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
        })
    },
    async getRolesForJob(){
        const roleHolder = await API.graphql({
            query: rolesFromJobsReader,
            variables: {
                input: {
                    request_type: 'find_role_by_job',
                    job_id: this.selectedJob
                }
            }
        });
        this.jobRoles = roleHolder.data.rolesFromJobsReader
    },
    async addCompanyRole(){
        if(this.selectedUser && (this.selectedJob || this.selectedRoles.length > 0)){
        try{
        await this.getRolesForJob()
        const ids = new Set(this.jobRoles.map(d => d.id));
        const merged = [...this.jobRoles, ...this.selectedRoles.filter(d => !ids.has(d.id))];
        for (let i = 0; i < merged.length; i++) {
        await API.graphql({
            query: personCompanyRoleHandler,
            variables: {
                input: {
                    request_type: 'add',
                    email: this.selectedUser,
                    company_id: this.id,
                    user_id: "11",
                    role_id: merged[i].id
                }
            }
            });
        }
        this.$emit('close')
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `User added.`,
                    position: 'is-bottom',
                    type: 'is-success',
                    hasIcon: true
          }) 
        } catch(e) {
            console.log(e)
        }
        } else {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `You must input valid values for all fields. The selected user must exist and you must provide a job set or at least one role.`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
          })
        }
    }
    },
    created(){
        this.getUsers()
        this.getRoles()
        this.getJobsForCompany()
    }
}
</script>
